export const STATUS_TEXT_TO_CODE = {
  FINALIZED: 'ready',
  PENDING: 'pending',
  OBSERVATION: 'observation',
  INPATIENT: 'inpatient',
  ED: 'ed',
  COMPLETED: 'completed',
  FINALIZED_A2: 'finalized_a2',
  FINALIZED_A1: 'finalized_a1',
  CONFLICTS_PENDING: 'conflicts_pending',
  DRAFT: 'draft',
} as const;

export type StatusText = keyof typeof STATUS_TEXT_TO_CODE;
export type StatusCode = (typeof STATUS_TEXT_TO_CODE)[StatusText];

export function getStatusCode(text: StatusText): StatusCode {
  return STATUS_TEXT_TO_CODE[text.toUpperCase() as StatusText];
}
